import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import { ALLERGEN_ICON_PATHS } from './allergen-icon-paths';

export function SesameIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d={ALLERGEN_ICON_PATHS.sesame} />
    </SvgIcon>
  );
}
